import { DemandComplianceModules, GeneralModules, Organisation, RiskManagementModules } from '../api/schemas/schema'

export const areModulesActiveInOrganisation = (organisation: Organisation, modules: (GeneralModules | DemandComplianceModules | RiskManagementModules)[]) => {
   const isAllowed = organisation?.modules?.some((module) => {
      if (!module.isActivated) return false

      const hasGeneral = module.generalModule != null && modules.includes(module.generalModule)
      const hasRisk = module.riskManagementModule != null && modules.includes(module.riskManagementModule)

      return hasGeneral || hasRisk
   })

   return !!isAllowed
}
